/**
 * Backend Pack Phase 4 — nav-rail unread badge total. Inbox.tsx already polls
 * GET /api/tickets every 15s; this context just makes the `counts.unread`
 * value from that SAME response available to Layout.tsx (the nav rail, a
 * sibling of Inbox — mounted once at the top of the tenant route tree, above
 * both). No new poll loop is created here.
 */

import { createContext, useContext, useState, type ReactNode } from 'react';

interface UnreadContextValue {
  total: number;
  setTotal: (n: number) => void;
}

const UnreadContext = createContext<UnreadContextValue>({ total: 0, setTotal: () => {} });

export function UnreadProvider({ children }: { children: ReactNode }) {
  const [total, setTotal] = useState(0);
  return (
    <UnreadContext.Provider value={{ total, setTotal }}>
      {children}
    </UnreadContext.Provider>
  );
}

export function useUnread(): UnreadContextValue {
  return useContext(UnreadContext);
}
